<template>
  <div>

    <div
      v-for="(bar,index) in bars"
      :key="index"
      class="mt-1"
    >
      <h4>{{ bar.projectName }} <small>
        <b-link
          @click="calculateScores(bar.projectId)"
        >Calculate Scores</b-link>
        <b-link
          class="ml-1"
          @click="forcedCalculation(bar.projectId)"
        >Forced Calculation</b-link>
      </small></h4>
      <label>{{ bar.calculatedCount }} of {{ bar.recordCount }} periods completed</label>
      <b-progress
        height="2rem"
        :max="100"
        class="progress-bar-success"
      >
        <b-progress-bar
          :animated="((bar.calculatedCount / bar.recordCount) * 100)<100"
          :value="((bar.calculatedCount / bar.recordCount) * 100).toFixed(2)"
          :label="`${((bar.calculatedCount / bar.recordCount) * 100).toFixed(2)}%`"
          :variant="((bar.calculatedCount / bar.recordCount) * 100)<100?'warning':'success'"
        />
      </b-progress>

    </div>
  </div>
</template>

<script>
import { BProgress, BProgressBar, BLink } from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BLink,
    BProgress,
    BProgressBar,
  },
  data: () => ({
    timer: null,
    bars: [],
  }),
  mounted() {
    this.timer = setInterval(() => {
      this.getData()
    }, 2000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  created() {
    this.getData()
  },
  methods: {
    calculateScores(projectId) {
      this.$swal({
        icon: 'success',
        title: 'In Progress!',
        text: 'Calculation is in progress...',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
      useJwt.axiosIns.get(`project/CalculateScores/${projectId}`)
        .then(response => {
          if (response.data === 'Ok') {
            this.$swal({
              icon: 'success',
              title: 'Completed!',
              text: 'Calculation is completed.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          } else {
            this.$swal({
              icon: 'error',
              title: 'Error!',
              text: 'Some error(s) ocurred!',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            })
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    forcedCalculation(projectId) {
      this.$swal({
        icon: 'success',
        title: 'In Progress!',
        text: 'Re Calculation is in progress...',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
      useJwt.axiosIns.get(`project/ReCalculateScores/${projectId}`)
        .then(response => {
          if (response.data === 'Ok') {
            this.$swal({
              icon: 'success',
              title: 'Completed!',
              text: 'Re-Calculation is completed.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          } else {
            this.$swal({
              icon: 'error',
              title: 'Error!',
              text: 'Some error(s) ocurred!',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            })
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    variant(value) {
      if (value === 100) {
        return 'success'
      }
      if (value === 0) {
        return 'danger'
      }
      return 'info'
    },
    getData() {
      useJwt.axiosIns.get('project/CalculationStatus')
        .then(response => {
          if (response.data) {
            this.bars = response.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>
